import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CnpjaOfficeResponse} from '@gatewee/types/cnpja';

@Injectable({
  providedIn: 'root',
})
export class CnpjaOpenService {
  private readonly officeUrl = 'https://open.cnpja.com/office';

  constructor(private readonly http: HttpClient) {}

  fetchOffice(taxId: string): Observable<CnpjaOfficeResponse> {
    const clean = taxId.replace(/\D/g, '');
    return this.http.get<CnpjaOfficeResponse>(`${this.officeUrl}/${clean}`);
  }
}
